module.exports = __webpack_public_path__ + "img/mind_template_item_2_8.a24813f3.png";